<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <!-- <b-card-text>transaction.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row
            v-if="datadetail"
            class="invoice-preview"
          >

            <!-- Col: Left (Invoice Container) -->
            <b-col
              cols="12"
              xl="9"
              md="8"
            >
              <b-card
                no-body
                class="invoice-preview-card"
              >
                <!-- Header -->
                <b-card-body class="invoice-padding pb-0">

                  <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-2">
                    <!-- Header: Left Content -->
                    <div class="logo-wrapper">
                      <h5 class="text-primary invoice-logo">
                        Detail Transaksi
                      </h5>
                    </div>
                    <!-- Header: Right Content -->
                    <div class="mt-md-0">
                      <h4 class="invoice-title">
                        <span class="invoice-number">#{{ datadetail.id }}</span>
                      </h4>
                      <!-- <div class="invoice-date-wrapper">
                        <p class="invoice-date-title">
                          Invoice :
                        </p>
                        <p class="invoice-date">
                          {{ datadetail.invoice_number }}
                        </p>
                      </div>
                      <div class="invoice-date-wrapper">
                        <p class="invoice-date-title">
                          Consultation Number :
                        </p>
                        <p class="invoice-date">
                          {{ datadetail.consultation_number }}
                        </p>
                      </div>
                      <div class="invoice-date-wrapper">
                        <p class="invoice-date-title">
                          Tanggal :
                        </p>
                        <p class="invoice-date">
                          {{ dateFormat(datadetail.date) }}
                        </p>
                      </div> -->
                    </div>
                  </div>
                </b-card-body>

                <!-- Spacer -->
                <hr class="invoice-spacing">

                <!-- Invoice Client & Payment Details -->
                <b-card-body
                  v-if="datadetail"
                  class="invoice-padding pt-0"
                >
                  <b-row class="invoice-spacing">

                    <!-- Col: Pengguna Jasa -->
                    <b-col
                      cols="12"
                      xl="6"
                      class="p-0"
                    >
                      <h6 class="mb-2">
                        Pengguna Jasa
                      </h6>
                      <h6 class="mb-25">
                        {{ datadetail.user_name }}
                      </h6>
                      <p class="card-text mb-25">
                        {{ datadetail.user_email }}
                      </p>
                      <h6 class="mb-2">&nbsp;</h6>
                      <h6 class="mb-2">
                        Penyedia Jasa
                      </h6>
                      <h6 class="mb-25">
                        {{ datadetail.practition_name }} - {{ datadetail.practition_profession }}
                      </h6>
                      <p class="card-text mb-25">
                        {{ datadetail.practition_email }}
                      </p>
                    </b-col>

                    <!-- Col: Payment Details -->
                    <b-col
                      xl="6"
                      cols="12"
                      class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end"
                    >
                      <div>
                        <h6 class="mb-2">
                          Invoice Detail
                        </h6>
                        <table>
                          <template v-for="(r_payment, indexs) in datadetail.payment">
                            <tbody v-bind:key="indexs">
                              <tr>
                                <td class="pr-1">Invoice</td>
                                <td class="pr-1"> : </td>
                                <td> {{ datadetail.invoice_number }}</td>
                              </tr>
                              <tr>
                                <td class="pr-1">Consultation</td>
                                <td class="pr-1"> : </td>
                                <td> {{ datadetail.consultation_number }}</td>
                              </tr>
                              <tr>
                                <td class="pr-1">Tanggal</td>
                                <td class="pr-1"> : </td>
                                <td> {{ dateFormat(datadetail.date) }}</td>
                              </tr>
                              <tr>
                                <td class="pr-1">Status</td>
                                <td class="pr-1"> : </td>
                                <td><b-badge :variant="status[1][r_payment.status]">{{ status[0][r_payment.status] }}</b-badge></td>
                              </tr>
                              <tr>
                                <td class="pr-1">Payment</td>
                                <td class="pr-1"> : </td>
                                <td> <b-badge :variant="payment[1][r_payment.payment_method]">{{ payment[0][r_payment.payment_method] }}</b-badge></td>
                              </tr>
                              <tr>
                                <td class="pr-1">Ext ID</td>
                                <td class="pr-1"> : </td>
                                <td> {{ r_payment.external_id }}</td>
                              </tr>
                              <tr>
                                <td class="pr-1">Amount</td>
                                <td class="pr-1"> : </td>
                                <td> {{ formatPrice(r_payment.amount) }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </table>
                      </div>
                    </b-col>
                  </b-row>
                </b-card-body>

                <!-- Invoice Description: Table -->
                <b-table-lite
                  responsive
                  :items="datadetail.detail"
                  :fields="['legal_service_name', 'start_service', 'end_service', 'user_profession_legal_service_price', 'legal_service_duration', 'sub_total']"
                >
                  <template #cell(user_profession_legal_service_price)="data">
                    <b-card-text class="font-weight-bold mb-25">
                      {{ formatPrice(data.item.user_profession_legal_service_price) }}
                    </b-card-text>
                  </template>
                  <template #cell(start_service)="data">
                    <b-card-text class="text-nowrap">
                      {{ dateFormat(data.item.start_service) }}
                    </b-card-text>
                  </template>
                  <template #cell(end_service)="data">
                    <b-card-text class="text-nowrap">
                      {{ dateFormat(data.item.end_service) }}
                    </b-card-text>
                  </template>
                  <template #cell(legal_service_duration)="data">
                    <b-card-text class="text-nowrap">
                      {{ data.item.legal_service_duration }} - {{ data.item.legal_service_duration_unit }}
                    </b-card-text>
                  </template>
                  <template #cell(sub_total)="data">
                    <b-card-text class="text-nowrap">
                      {{ formatPrice(data.item.sub_total) }}
                    </b-card-text>
                  </template>
                </b-table-lite>

                <!-- Invoice Description: Total -->
                <b-card-body class="invoice-padding pb-0">
                  <b-row>

                    <!-- Col: Sales Persion -->
                    <b-col
                      cols="12"
                      md="6"
                      class="mt-md-0 mt-3"
                      order="2"
                      order-md="1"
                    >
                    </b-col>

                    <!-- Col: Total -->
                    <b-col
                      cols="12"
                      md="6"
                      class="mt-md-6 d-flex justify-content-end"
                      order="1"
                      order-md="2"
                    >
                      <div class="invoice-total-wrapper">
                        <div class="invoice-total-item">
                          <p class="invoice-total-title">
                            Subtotal :
                          </p>
                          <p class="invoice-total-amount">
                            {{ formatPrice(datadetail.sub_total) }}
                          </p>
                        </div>
                        <!-- <div class="invoice-total-item">
                          <p class="invoice-total-title">
                            Discount:
                          </p>
                          <p class="invoice-total-amount">
                            $28
                          </p>
                        </div> -->
                        <div class="invoice-total-item">
                          <p class="invoice-total-title">
                            Pajak :
                          </p>
                          <p class="invoice-total-amount">
                            {{ formatPrice(datadetail.taxes) }}
                          </p>
                        </div>
                        <hr class="my-50">
                        <div class="invoice-total-item">
                          <p class="invoice-total-title">
                            Total :
                          </p>
                          <p class="invoice-total-amount">
                            {{ formatPrice(datadetail.total) }}
                          </p>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-card-body>

                <!-- Spacer -->
                <hr class="invoice-spacing">

                <!-- Note -->
                <!-- <b-card-body class="invoice-padding pt-0">
                  <span class="font-weight-bold">Note: </span>
                  <span>It was a pleasure working with you and your team. We hope you will keep us in mind for future freelance
                    projects. Thank You!</span>
                </b-card-body> -->
              </b-card>
            </b-col>

            <!-- Right Col: Card -->
            <b-col
              cols="12"
              md="4"
              xl="3"
              class="invoice-actions"
            >
              <b-card>
                <b-form-group label="Type" label-for="v-type">
                  <validation-provider #default="{ errors }" name="Type" >
                    <v-select
                      v-model="form.select_1"
                      placeholder="Chose Type" autocomplete="off" 
                      :state="errors.length > 0 ? false:null"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :reduce="option_1 => option_1.value"
                      :options="option_1"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- Button: Edit -->
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="outline-secondary"
                  class="mb-75"
                  block
                  @click.prevent="validationForm"
                >
                  Update
                </b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BBadge, BCardBody, BTableLite, BOverlay, BCol, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BFormCheckbox, BFormFile, BForm, BButton, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BImg } from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { vSelect, BCardBody, BTableLite, BOverlay, ValidationProvider, ValidationObserver, BInputGroup, BInputGroupAppend, BFormCheckbox, BCard, BCardText, BRow, BBadge, BCol, BFormGroup, BFormInput, BFormFile, BForm, BButton, BMedia, BMediaAside, BMediaBody, BLink, BImg },
  directives: { Ripple },
  data () {
    return { 
        AC: 'Aktif Belum Dibayar', WC: 'Menunggu Konfirmasi', DC: 'Tolak Konsultasi', SC: 'Aktif Sudah Dibayar', EC: 'Pembayaran Expired',LS: 'Sedang Layanan Hukum', ED: 'Transaksi Selesai', SH: 'Terjadwal',

      option_1: [{ value: 'WC', title: 'Menunggu Konfirmasi' }, { value: 'DC', title: 'Tolak Konsultasi' }, { value: 'SC', title: 'Aktif Sudah Dibayar' }, { value: 'EC', title: 'Pembayaran Expired' }, { value: 'LS', title: 'Sedang Layanan Hukum' }, { value: 'ED', title: 'Transaksi Selesai' }, { value: 'SH', title: 'Terjadwal' }],
      option_2: [{ value: 'Second', title: 'Second' }, { value: 'Minute',title: 'Minute' }, { value: 'Hour', title: 'Hour' }, { value: 'Day', title: 'Day' }],
      form: {id: null, text_1: '',text_2: '',text_3: '',checkbox_4: false,select_1: {value: 'OC'},text_6: '',select_7: {value:'Minute'}},
      datadetail: [],
      show: false,
      required,
      status: [{
        WP: 'Menunggu Konfirmasi', AC: 'Aktif Belum Bayar', DC: 'Tolak Konsultasi', SC: 'Aktif Sudah Dibayar', EC: 'Pembayaran Expired',LS: 'Sedang Layanan Hukum', ED: 'Transaksi Selesai', SH: 'Terjadwal',
      },
      {
        WP: 'light-primary', AC: 'light-success', DC: 'light-danger', EC: 'light-warning', SC: 'light-info', LS: 'light-info', ED: 'light-info', SH: 'light-info',
      }],
      payment: [{
        XD: 'Xendit', JH: 'Universal IOT', MT: 'Midtrans',
      },
      {
        XD: 'light-primary', JH: 'light-primary', MT: 'light-primary',
      }]
    }
  },
  computed: {
    dateFormat () {
      return create_at => this.$options.filters.formatDate(create_at)
    },
  },
  methods: {
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('transaction/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('transaction/getById', id).then(data => {
        this.form.id = data.id
        this.datadetail = data
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {

  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
              > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
</style>